import {IronCondorTradeIdeaRecord} from "../../../../../models/TradeIdeaRecord";

export class IronCondorValueDomain {

    private readonly range: number;

    private constructor(private readonly min: number, private readonly max: number) {
        this.range = max - min;
    }

    public position(value: number): number {
        return ((value - this.min) / this.range) * 100;
    }

    public static create(idea: IronCondorTradeIdeaRecord): IronCondorValueDomain {
        const min = idea.boughtPut.strike;
        const max = idea.boughtCall.strike;
        return new IronCondorValueDomain(min, max);
    }
}
